<template>
    <div>
        <div style="padding-bottom:10px;display: flex;transition: .25s;" :style="{'height':topHeight+'px'}">
            <div style="flex:5;display: flex;flex-direction: column;">
                <div style="display:flex;flex:1">
                    <div class="sp-card" style="flex:1;">
                        <div id="purchase7" style="width:100%;height:100%"></div>
                    </div>
                    <div style="width:10px"></div>
                    <div class="sp-card" style="flex:1;">
                        <div id="purchase8" style="width:100%;height:100%"></div>
                    </div>
                </div>
                <div style="height:10px"></div>
                <div class="sp-card" style="flex:1">
                    <div id="purchase1" style="width:100%;height:100%"></div>
                </div>
            </div>
            <div style="width:10px"></div>
            <div class="sp-card" style="flex:2" id="spe2">
                <div id="purchase2" style="width:100%;height:100%"></div>
            </div>
        </div>
        <div class="grid-box-sc" :style="{'height':rankHeight+'px'}">
            <div class="sp-card" id="spe1">
                <div id="purchase3" style="width:100%;height:100%;"></div>
            </div>
            <div class="sp-card">
                <div id="purchase4" style="width:100%;height:100%;"></div>
            </div>
            <div class="sp-card">
                <div id="purchase5" style="width:100%;height:100%;"></div>
            </div>
            <div class="sp-card">
                <div id="purchase6" style="width:100%;height:100%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            element:{
                totalNum:0,
                totalCost:0,
            },
            chartList:[null,null,null,null,null,null,null,null],
            isShowPage:false,
            rankHeight:0,
            topHeight:0,
        }
    },
    methods:{
        checkHeight:function(){
            let width = document.getElementById('spe1').clientWidth;
            this.rankHeight = Math.ceil(width);
            let scwidth = document.getElementById('spe2').clientWidth;
            this.topHeight = Math.ceil(scwidth*1.25);
            let windowheight = window.innerHeight;
            if(this.rankHeight+this.topHeight>windowheight){
                this.rankHeight = Math.floor(windowheight*0.36)
                this.topHeight = Math.floor(windowheight*0.54)
            }
        },
        setResize(){
            this.checkHeight();
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.$nextTick(()=>{
                this.checkHeight();
                this.isShowPage = true;
                setTimeout(()=>{
                    this.getInfo();
                },250)
            })
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('purchase'+(key+1)));
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.mListOrder(obj).then(res=>{
                let temp = res.data.data;
                this.element.totalNum = temp.total;
                this.element.totalCost = temp.presentMoneySum;
                if(true){
                    let myChart = this.getMyChart(7);
                    if(myChart){
                        let arr = [];
                        arr.push({name:'已支付',count:temp.paySum})
                        arr.push({name:'已免除',count:temp.freeSum})
                        let opt = this.getOption(arr,'采购订单金额');
                        myChart.setOption(opt);
                    }
                }
                this.$api.mListOrder({state:'2,3,4',...obj}).then(res1=>{
                    let pass = res1.data.data.total;
                    let nopass = this.element.totalNum - pass;
                    let myChart = this.getMyChart(6);
                    let arr = [];
                    arr.push({name:'通过',value:pass});
                    arr.push({name:'未通过',value:nopass});
                    if(myChart){
                        let option = {
                            title:{
                                text:'采购订单',
                                left:'left',
                            },
                            tooltip: {
                                trigger: 'item'
                            },
                            color:[
                                '#67c23a',
                                '#f56c6c',
                            ],
                            legend: {
                                orient: 'vertical',
                                left:'left',
                                bottom:'10px',
                            },
                            series: [{
                                name: 'Access From',
                                type: 'pie',
                                radius: ['40%', '70%'],
                                avoidLabelOverlap: false,
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontSize: 20,
                                        fontWeight: 'bold'
                                    }
                                },
                                labelLine: {
                                    show: false
                                },
                                data:arr,
                            }]
                        };
                        myChart.setOption(option);
                    }
                })
            });
            
            this.$api.listProductSpec({page:1,limit:10,stock:1,column:'stockAmount',order:'desc'}).then(res=>{
                let arr = [];
                res.data.data.data.forEach(e=>{
                    if(e.amount>0){
                        let spec = "";
                        if(e.spec1){
                            spec += "_"+e.spec1;
                        }
                        if(e.spec2){
                            spec += "_"+e.spec2;
                        }
                        let obj = {
                            id:e.id,
                            amount:e.amount,
                            name:e.name+spec,
                            packing:e.packing,
                        }
                        arr.unshift(obj);
                    }
                })
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        title:{
                                text:'材料库存详情',
                                left:'left',
                            },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        grid:{
                            top: '10%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            show:false,
                        },
                        yAxis: {
                            type: 'category',
                            data: arr.map(e=>e.name)
                        },
                        yAxis: {
                            type: 'category',
                            data:arr.map(e=>e.name),
                            axisLabel:{
                                formatter:function(value){
                                    var res = value;
                                    if(res.length>6){
                                        res = res.substring(0,5)+'...';
                                    }
                                    return res;
                                }
                            },
                        },
                        series: [
                            {
                                name:'库存',
                                data: arr.map(e=>e.amount),
                                type: 'bar',
                            },
                        ]
                    };
                    myChart.setOption(option);
                }
            })
            this.$api.getMaterialOrderSumGroupByS({page:1,limit:10,...obj}).then(res=>{
                let dd = res.data.data.data;
                let arr = [];
                dd.forEach(e=>{
                    let obj = {
                        name:e.sp_name,
                        money:e.moneySum,
                    }
                    arr.push(obj);
                })
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        title:{
                            text:'采购金额',
                            left:'left',
                        },
                        grid:{
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true,
                        },
                        // legend: {
                        //     top: 'top'
                        // },
                        xAxis: {
                            type: 'category',
                            data: arr.map(e=>e.name)
                        },
                        yAxis: {
                            show:false,
                            type: 'value',
                            name: '单位:（元）',
                            splitNumber:5,
                        },
                        series: [
                            {
                                name:'采购',
                                data: arr.map(e=>e.money),
                                type: 'bar',
                                color:'#FE9526'
                            }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
            this.$api.listSupply({page:1,limit:5,column:'needPay',order:'desc',...obj}).then(res=>{
                let dd = res.data.data.data;
                let itemList = [];
                dd.forEach(e=>{
                    itemList.unshift({
                        name:e.name,
                        count:e.needPay,
                    })
                })
                let myChart = this.getMyChart(2);
                if(myChart){
                    let opt = this.getOption(itemList,'采购应付');
                    myChart.setOption(opt);
                }
            })
            this.$api.listSupply({page:1,limit:5,column:'pay',order:'desc',...obj}).then(res=>{
                let dd = res.data.data.data;
                let itemList = [];
                dd.forEach(e=>{
                    itemList.unshift({
                        name:e.name,
                        count:e.pay,
                    })
                })
                let myChart = this.getMyChart(3);
                if(myChart){
                    let opt = this.getOption(itemList,'采购已付');
                    myChart.setOption(opt);
                }
            })
            this.$api.listSupply({page:1,limit:5,column:'needReceive',order:'desc',...obj}).then(res=>{
                let dd = res.data.data.data;
                let itemList = [];
                dd.forEach(e=>{
                    itemList.unshift({
                        name:e.name,
                        count:e.needReceive,
                    })
                })
                let myChart = this.getMyChart(4);
                if(myChart){
                    let opt = this.getOption(itemList,'退货应收');
                    myChart.setOption(opt);
                }
            })
            this.$api.listSupply({page:1,limit:5,column:'received',order:'desc',...obj}).then(res=>{
                let dd = res.data.data.data;
                let itemList = [];
                dd.forEach(e=>{
                    itemList.unshift({
                        name:e.name,
                        count:e.received,
                    })
                })
                let myChart = this.getMyChart(5);
                if(myChart){
                    let opt = this.getOption(itemList,'退货收款');
                    myChart.setOption(opt);
                }
            })
        },
        getOption:function(arr,title){
            let color='';
            if(title=='采购应付'){
                color = "#2EC7C9";
            }else if(title=='采购已付'){
                color = "#3E77FA";
            }else if(title=='退货应收'){
                color = "#FFB980";
            }else if(title=='退货收款'){
                color = "#FF005A";
            }else if(title=='采购订单金额'){
                color = "#C8B2F4";
            }
            let option = {
                title:{
                    text:title,
                    left:'left',
                },
                color:[
                    color,
                ],
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top: '15%',
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    show:false,
                },
                yAxis: {
                    type: 'category',
                    data:arr.map(e=>e.name),
                    axisLabel:{
                        formatter:function(value){
                            var res = value;
                            if(res.length>3){
                                res = res.substring(0,2)+'...';
                            }
                            return res;
                        }
                    },
                },
                series: [
                    { type: 'bar',data:arr.map(e=>e.count)},
                ]
            };
            return option;
        }
    }
}
</script>
<style lang="scss" scoped>
.grid-box-sc{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
    transition: .25s;
}
</style>